/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

import { ConfigurationVariables } from "../../../config";
import JSEncrypt from "jsencrypt";

export function getEncryptedSecretWithPublicKey(targetValue: any): any {
  const publicKey = ConfigurationVariables.Tenant_Settings_Public_Key;

  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);

  const encryptedString = encrypt.encrypt(targetValue);
  return encryptedString;
}

// Dummy commit
